import "./src/styles/global.css"
export const onClientEntry = () => {
  document.addEventListener("contextmenu", (e) => e.preventDefault())
}